"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListView = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var classnames_1 = require("../util/classnames");
var vdl_prefix_1 = require("../util/vdl-prefix");
var checkbox_1 = require("../checkbox");
var angle_right_1 = __importDefault(require("adp-react-icons/lib/fa/angle-right"));
var angle_up_1 = __importDefault(require("adp-react-icons/lib/fa/angle-up"));
var ListView = /** @class */function (_super) {
  __extends(ListView, _super);
  function ListView(props) {
    var _this = _super.call(this, props) || this;
    _this.state = {};
    _this.onCheckboxItemSelected = function (selected) {
      _this.setState({
        selected: !selected
      });
    };
    _this.handleClick = function () {
      var _a = _this.props,
        onSelect = _a.onSelect,
        selectable = _a.selectable,
        disabled = _a.disabled,
        expandable = _a.expandable;
      var _b = _this.state,
        selected = _b.selected,
        isExpanded = _b.isExpanded;
      if (disabled) {
        return;
      }
      if (selectable) {
        _this.setState({
          selected: !selected
        });
      }
      if (expandable) {
        _this.setState({
          isExpanded: !isExpanded
        });
      }
      if (onSelect) {
        onSelect();
      }
    };
    return _this;
  }
  ListView.prototype.renderCheckbox = function () {
    var selected = this.state.selected;
    var disabled = this.props.disabled;
    return react_1.default.createElement("div", {
      className: vdl_prefix_1.vdlPrefix('list-view__select-element')
    }, react_1.default.createElement(checkbox_1.Checkbox, {
      checked: selected,
      disabled: disabled,
      onChange: this.onCheckboxItemSelected
    }));
  };
  ListView.prototype.renderExpandedContent = function () {
    var children = this.props.children;
    return react_1.default.createElement("div", {
      className: vdl_prefix_1.vdlPrefix('list-view__expand-content')
    }, react_1.default.createElement("div", {
      className: vdl_prefix_1.vdlPrefix('list-view__expand-content-align')
    }, children));
  };
  ListView.prototype.renderActions = function () {
    var isExpanded = this.state.isExpanded;
    var expanded = this.props.expanded;
    return react_1.default.createElement("div", {
      className: vdl_prefix_1.vdlPrefix('list-view__actions')
    }, isExpanded || expanded ? react_1.default.createElement(angle_up_1.default, null) : react_1.default.createElement(angle_right_1.default, null));
  };
  ListView.prototype.render = function () {
    var _a, _b;
    var _c = this.props,
      className = _c.className,
      children = _c.children,
      disabled = _c.disabled,
      expandable = _c.expandable,
      selectable = _c.selectable,
      status = _c.status,
      showCheckbox = _c.showCheckbox;
    var _d = this.state,
      selected = _d.selected,
      isExpanded = _d.isExpanded;
    var listViewClasses = (_a = {}, _a[vdl_prefix_1.vdlPrefix('list-view')] = true, _a[vdl_prefix_1.vdlPrefix(status ? status : 'default')] = true, _a['actionable'] = selectable || expandable, _a[vdl_prefix_1.vdlPrefix('list-view--selected')] = selected, _a);
    var listViewRowClasses = (_b = {}, _b[vdl_prefix_1.vdlPrefix('list-view__row')] = true, _b[vdl_prefix_1.vdlPrefix('list-view__row--disabled')] = disabled, _b);
    return react_1.default.createElement("div", {
      className: classnames_1.classNames(className, listViewClasses),
      onClick: this.handleClick
    }, react_1.default.createElement("div", {
      className: classnames_1.classNames(listViewRowClasses)
    }, react_1.default.createElement("div", {
      className: vdl_prefix_1.vdlPrefix('list-view__content')
    }, showCheckbox && this.renderCheckbox(), react_1.default.createElement("div", {
      className: "vdl-list-view__content-align"
    }, children)), expandable && this.renderActions()), isExpanded && this.renderExpandedContent());
  };
  ListView.propTypes = {
    className: prop_types_1.default.string,
    disabled: prop_types_1.default.bool,
    expandable: prop_types_1.default.bool,
    expanded: prop_types_1.default.bool,
    onSelect: prop_types_1.default.func,
    selectable: prop_types_1.default.bool,
    showCheckbox: prop_types_1.default.bool,
    status: prop_types_1.default.oneOf(['info', 'error', 'success', 'warning', 'default'])
  };
  return ListView;
}(react_1.default.Component);
exports.ListView = ListView;